import { render, staticRenderFns } from "./billGame.vue?vue&type=template&id=3cbf137a&scoped=true"
import script from "./billGame.vue?vue&type=script&lang=js"
export * from "./billGame.vue?vue&type=script&lang=js"
import style0 from "./billGame.vue?vue&type=style&index=0&id=3cbf137a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf137a",
  null
  
)

export default component.exports